export default "__VITE_ASSET__CCRPzGIe__"